module.exports = __webpack_public_path__ + "static/img/10.2d8f812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/10.png
// module id = DzMl
// module chunks = 35